var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-header" }, [
      _c("img", { attrs: { src: _vm.siteInfo.siteLogo } }),
      _vm._v(" "),
      _c("div", { staticClass: "page-header-title" }, [
        _c("h5", { staticClass: "site-title" }, [
          _vm._v(_vm._s(_vm.siteInfo.siteName))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "site-desc" }, [
          _vm._v(_vm._s(_vm.siteInfo.siteDesc))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "home-nav" },
      [
        _c(
          "van-row",
          { attrs: { type: "flex", justify: "center" } },
          [
            _c("van-col", { attrs: { span: "6" } }, [
              _c(
                "div",
                {
                  staticClass: "flex-content",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "index" })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/query.fd2e6f2c.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("查询")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("van-col", { attrs: { span: "6" } }, [
              _c(
                "div",
                {
                  staticClass: "flex-content",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "order" })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/order.edc98302.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("续费记录")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("van-col", { attrs: { span: "6" } }, [
              _c(
                "div",
                {
                  staticClass: "flex-content",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "bind" })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/auth.46bece58.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实名绑定")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("van-col", { attrs: { span: "6" } }, [
              _c(
                "div",
                {
                  staticClass: "flex-content",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "feedback" })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/feedback.eb8634f3.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("投诉建议")])
                ]
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e8c3c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 